import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { BiTrash } from 'react-icons/bi'
import { useDispatch, useSelector } from 'react-redux'
import { getCoursesList, deleteCourse } from '../../actions/courses'
import { getLessons } from '../../actions/common'
import Loader from '../../components/Loader'
import Modal from './modal'
import Table from '../../components/Table'
import Confirmation from '../../components/Confirmation/Confirmation'
import { Input } from '../../components/ModalInputs'

// status: "2" — предмет идёт, "1" (и легаси "0") — закрыт
const statusName = (status) => Number(status) === 2 ? 'Идет' : 'Закрыт'
const flag = (value) => Number(value) === 1 ? 'Да' : 'Нет'

export default function Courses() {

  const dispatch = useDispatch()
  const { list, count, loading } = useSelector(state => state.courses)
  const { lessons } = useSelector(state => state.common)

  const [addMode, setAddMode] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [confirmation, setConfirmation] = useState(false)
  const [search, setSearch] = useState('')
  const firstRender = useRef(true)

  const listParams = search ? { title_search: search } : {}

  useEffect(() => {
    dispatch(getLessons())
    dispatch(getCoursesList())
  }, [])

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    const timeout = setTimeout(() => {
      dispatch(getCoursesList(search ? { title_search: search } : {}))
    }, 400)
    return () => clearTimeout(timeout)
  }, [search])

  const openModal = (id) => () => {
    setSelectedId(id)
    setAddMode(id === 'add')
  }

  const closeModal = () => {
    setSelectedId(null)
    setAddMode(false)
  }

  const acceptConfirmation = () => {
    dispatch(deleteCourse(confirmation.id, listParams))
    setConfirmation(false)
  }

  const rejectConfirmation = () => setConfirmation(false)

  const renderRow = (data) => {
    const { cid, title, lid, status, xp_paired, needhomework, neednt_grades, skip_attestat, ege, gia, sort } = data
    const lessonName = lessons?.find(lesson => lesson.lid === lid)?.name
    return (
      <tr key={cid} onClick={openModal(cid)}>
        <td className={styles.tdName}>{title}</td>
        <td className={styles.tdName}>{lessonName || '—'}</td>
        <td>{statusName(status)}</td>
        <td>{flag(xp_paired)}</td>
        <td>{flag(needhomework)}</td>
        <td>{flag(neednt_grades)}</td>
        <td>{flag(skip_attestat)}</td>
        <td>{flag(ege)}</td>
        <td>{flag(gia)}</td>
        <td>{sort ?? '—'}</td>
        <td>
          <button
            type="button"
            className={styles.deleteBtn}
            onClick={(e) => { e.stopPropagation(); setConfirmation({ id: cid, title }) }}
            title="Удалить запись"
            aria-label="Удалить"
          >
            <BiTrash size={20} />
          </button>
        </td>
      </tr>
    )
  }

  const courses = list?.courses

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить предмет "${confirmation.title}"?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {(!!selectedId || addMode) &&
        <Modal
          closeModal={closeModal}
          selectedId={selectedId}
          addMode={addMode}
          list={courses}
          listParams={listParams}
          infoCreateChange={courses?.find(course => course.cid === selectedId)}
        />
      }
      <header className={styles.header}>
        <h1>Предметы</h1>
      </header>
      <main className={styles.content}>
        <div className={styles.searchRow}>
          <Input
            label='Поиск по названию'
            name='title_search'
            value={search}
            style={{ width: '320px' }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        {loading && !courses
          ? <Loader />
          : <Table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.thName}>Название</th>
                <th className={styles.thName}>Дисциплина</th>
                <th>Статус</th>
                <th>Парный урок</th>
                <th>Без ДЗ</th>
                <th>Без оценок</th>
                <th>Аттестат</th>
                <th>ЕГЭ</th>
                <th>ОГЭ</th>
                <th>Сортировка для аттестата</th>
                <th style={{ width: '70px' }}>Удалить</th>
              </tr>
            </thead>
            <tbody>
              {courses?.length
                ? courses.map(renderRow)
                : <tr><td className={styles.emptyRow} colSpan={11}>Ничего не найдено</td></tr>}
            </tbody>
          </Table>
        }
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal('add')}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {count || 0}</span>
        </div>
      </main>
    </div>
  )
}
